import {
    RESET_QUERY_LOADING, MENTOR_JOB_TITLES, MENTOR_SKILL, GET_MENTOR_LIST, GET_NEXT_MENTOR_LIST, ADD_MENTOR, CHANGE_MENTOR_STATUS,
    GET_CONVERSATION_LIST, GET_NEXT_CONVERSATION_LIST, ADD_QUERY, RESET_QUERY, Get_QUES_DETAILS, Close_Question_Details,
    ADMIN_REPLY_SENT, REPLY_SENT, JUNK_CONVERSATION, CLOSED_CONVERSATION, GET_MENTORS, DELETE_REPLY, BOOK_SESSION
} from '../../actionType/type';
import { getApiCall, postApiCall } from "../../utils/request";
import { returnErrors } from "../errorAction";


export const resetLoading = () => async (dispatch) => {
    return dispatch({
        type: RESET_QUERY_LOADING
    });
}

export const getJobTitles = () => async (dispatch) => {
    const response = await getApiCall(`admin/career/list`);
    if (response.data.success) {
        dispatch({ type: MENTOR_JOB_TITLES, payload: response.data.data });
    }
    else {
        returnErrors(dispatch, response.data.message, response.status)
    }
}


export const getSkills = () => async (dispatch) => {
    const response = await getApiCall(`admin/skills`);
    if (response.data.success) {
        dispatch({ type: MENTOR_SKILL, payload: response.data.data });
    }
    else {
        returnErrors(dispatch, response.data.message, response.status)
    }
}


export const getMentorList = (page, query) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/mentors?page=${page}&query=${query}`);
        if (response.data.success) {
            dispatch({ type: GET_MENTOR_LIST, payload: response.data.data })
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const getNextMentorList = (page, query) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/mentors?page=${page}&query=${query}`);
        if (response.data.success) {
            dispatch({ type: GET_NEXT_MENTOR_LIST, payload: response.data.data })
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const addMentor = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/mentors`, obj);
        if (response.data.success) {
            dispatch({ type: ADD_MENTOR, payload: response.data.data })
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const changeMentorStatus = (id, checked) => async (dispatch) => {
    const obj = {
        _id: id
    };
    try {
        const response = await postApiCall(`admin/mentors/toggle`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_MENTOR_STATUS, payload: { id, checked } });
            returnErrors(dispatch, checked ? 'Mentor is deactivated' : 'Mentor is activated', response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error?.response?.status);
    }
};

export const updatedMentor = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/mentors/edit`, obj);
        if (response.data.success) {
            // dispatch({ type: ADD_MENTOR, payload: response.data.data })
            returnErrors(dispatch, 'Mentor details is updated', response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};


export const replySentFromAdmin = (obj) => async (dispatch) => {
    try {
        await postApiCall('admin/conversation/reply', obj);
        dispatch({ type: ADMIN_REPLY_SENT, payload: obj });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const deleteReply = (id, c_id) => async (dispatch) => {
    const obj = {
        _id: id,
        conversation_id: c_id
    };
    try {
        const response = await postApiCall(`user/mentor/conversation/reply/delete`, obj);
        if (response.data.success) {
            dispatch({ type: DELETE_REPLY, payload: c_id });
            returnErrors(dispatch, 'Reply deleted', response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error?.response?.status);
    }
};




// Mentors 


export const getConversationList = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/mentor/conversation?page=${page}`);
        if (response.data.success) {
            dispatch({ type: GET_CONVERSATION_LIST, payload: response.data.data })
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const getNextConversationList = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/mentor/conversation?page=${page}`);
        if (response.data.success) {
            dispatch({ type: GET_NEXT_CONVERSATION_LIST, payload: response.data.data })
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const addQuery = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/mentor/conversation`, obj);
        if (response.data.success) {
            returnErrors(dispatch, response !== undefined && 'Query sent succesfully', response?.status);
            dispatch({ type: ADD_QUERY, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const resetQuery = () => async (dispatch) => {
    return dispatch({
        type: RESET_QUERY
    });
}

export const getQDetails = (details, id) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/mentor/conversation/reply?_id=${id}`)
        const data = response.data.data
        dispatch({ type: Get_QUES_DETAILS, payload: { details, data } });

    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const closeDetails = () => async (dispatch) => {
    return dispatch({
        type: Close_Question_Details

    })
}


export const replySent = (obj) => async (dispatch) => {
    try {
        await postApiCall('user/mentor/conversation/reply', obj);
        dispatch({ type: REPLY_SENT, payload: obj });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}


export const markasjunk = (id) => async (dispatch) => {

    let obj = {
        _id: id
    }
    let response
    try {
        response = await postApiCall('admin/conversation/junk', obj);
        if (response.data.success) {
            returnErrors(dispatch, 'Query marked as junk', response?.status);
            dispatch({ type: JUNK_CONVERSATION, payload: id });
        }
        else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }

    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const markasclosed = (id) => async (dispatch) => {
    let obj = {
        _id: id
    }
    let response
    try {
        response = await postApiCall('admin/conversation/close', obj);
        if (response.data.success) {
            returnErrors(dispatch, 'Query marked as closed', response?.status);
            dispatch({ type: CLOSED_CONVERSATION, payload: id });
        }
        else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }

    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const getMentors = () => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/conversation/mentors`);
        if (response.data.success) {
            dispatch({ type: GET_MENTORS, payload: response.data.data })
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const bookSession = (id) => async (dispatch) => {
    const obj = {
        mentor_id: id
    }
    try {
        const response = await postApiCall(`user/mentors/connect`, obj);
        if (response.data.success) {
            dispatch({ type: BOOK_SESSION, payload: response.data.data })
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};


